module.exports = "/assets/data/7a8648ce5e2c11eaa56352e0d1de57f3-AB23.data.json";